import React, { useState, useEffect } from 'react';
import {
  Box,
  CircularProgress,
  Alert
} from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import apiClient from '../../config/axios';
import { useAdmin } from '../../contexts/AdminContext';
import { TeacherReportsGrid, EnrollmentsPaymentGrid } from './reports/index';
import { exportTeacherReportsToCSV } from '../../utils/exportCSV/exportTeacherReports';

dayjs.locale('it');

const Reports = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { enrollments } = useAdmin();

  useEffect(() => {
    fetchTeacherReportsData();
  }, []);

  const fetchTeacherReportsData = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/api/finance/teacher-reports');
      setData(response.data);
    } catch (err) {
      setError('Errore nel caricamento dei dati dei docenti');
      console.error('Error fetching teacher reports data:', err);
    } finally {
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    exportTeacherReportsToCSV(data);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Teacher Reports Grid */}
      <TeacherReportsGrid 
        data={data} 
        onExportCSV={exportToCSV} 
      />

      {/* Enrollments Payment Status Grid */}
      <EnrollmentsPaymentGrid 
        enrollments={enrollments} 
      />
    </Box>
  );
};

export default Reports; 